import IPlayer from '../../core/IPlayer'
import IOption from '../../core/PlayerOptions'
import { loadScript } from '../../common/util'
import { ErrorCode, PlayerStatus } from '../../common/enums'
import PlayerConfig from '../../core/PlayerConfig'

class Source {
  label = ''
  src = ''
  type = ''
  qualityCode = 0
  url = ''
}

class OSource {
  quality = 0
  url = ''
}

class InitOption implements IOption {
  width?: string = '100%'
  height?: string = '100%'
  id = ''
  sources: Array<OSource> = new Array<OSource>()
  playerConfig: PlayerConfig = new PlayerConfig()
}

class HwCloudWebPlayer extends IPlayer {
  player: any
  options: InitOption = new InitOption()
  playerBox: HTMLElement

  /**
   * 初始化播放环境
   */
  static async installPlayerEvn() {
    if (!window.HWPlayer) {
      // await loadCss(['/statics/lib/video.js/video.min.css'])
      await loadScript(['/libs/video.js/hwplayer.js'])
    }
  }

  constructor(options: InitOption = new InitOption()) {
    super()
    this.options = Object.assign({}, this.options, options)
    this.options.playerConfig = Object.assign({}, this.options.playerConfig, options.playerConfig)
    if (!window.hwplayerloaded || Object.prototype.toString.call(window.hwplayerloaded) !== '[object Function]') {
      throw new Error('请加载相关设施后才能进行播放！')
    }
    this.playerBox = document.querySelector(`#${this.options.id}`) as HTMLElement
    const videoContainer = this.createPlayerVideo()
    window.hwplayerloaded(() => {
      videoContainer.className = 'video-js vjs-default-skin vjs-big-play-centered'
      this.player = new window.HWPlayer(this.options.id, this.options.playerConfig, () => {
        if (!this.setSource()) return
        this.bindTimeupdate()
        this.bindEvents()
        this.play(this.options.playerConfig.currentTime)
        if (!this.options.playerConfig.playbackRates?.length) {
          this.player.controlBar.playbackRateMenuButton.hide()
        }
      })
    })
  }

  private hideResolution() {
    this.player.controlBar.resolutionSwitcher.style.display = 'none'
  }

  private showResolution() {
    this.player.controlBar.resolutionSwitcher.style.display = 'block'
  }

  private setSource(): boolean {
    if (!this.options.sources || !this.options.sources.length) {
      this.emit(PlayerStatus.error, ErrorCode.sourceError)
      return false
    }
    const playUrl = this.options.sources[0].url
    if (HwCloudWebPlayer.isAudio(playUrl)) {
      this.player.on(PlayerStatus.paused, () => {
        this.setPoster('/libs/video.js/music_ico.png')
      })
      this.player.on(PlayerStatus.playing, () => {
        this.setPoster('/libs/video.js/music_ico.gif')
      })
      // 隐藏流畅度切换
      this.hideResolution()
    } else {
      this.player.updateSrc(this.transformSource(this.options.sources))
      this.showResolution()
    }
    this.player.src(playUrl)
    return true
  }

  static isVideo(url = '') {
    const replaceUrl = url.split('?')[0] || url
    return /(.m3u8|.mp4)$/.test(replaceUrl)
  }

  static isAudio(url = '') {
    const replaceUrl = url.split('?')[0] || url
    return /(.mp3)$/.test(replaceUrl)
  }

  updateSource(sources: Array<OSource> | any) {
    this.options.sources = sources
    this.setSource()
  }

  setPoster(url: string) {
    this.player.poster(url)
  }

  private transformSource(source: Array<OSource>) {
    if (!Array.isArray(source)) {
      return []
    }
    const resource: Array<Source> = new Array<Source>()
    source.forEach(item => {
      if (HwCloudWebPlayer.isVideo(item.url)) {
        const qualityMap = new Map<number, string>()
        qualityMap.set(1, '流畅普屏')
        qualityMap.set(2, '标清普屏')
        qualityMap.set(3, '高清普屏')
        qualityMap.set(4, '流畅宽屏')
        qualityMap.set(5, '标清宽屏')
        qualityMap.set(6, '高清宽屏')
        qualityMap.set(7, '超清宽屏')
        qualityMap.set(8, '流畅')
        qualityMap.set(9, '标清')
        qualityMap.set(10, '高清')
        qualityMap.set(11, '超清')
        const quality = qualityMap.get(item.quality) || '未知'
        const source = new Source()
        source.label = quality
        source.qualityCode = item.quality
        source.src = item.url
        source.type = 'application/mpegurl'
        resource.push(source)
      }
    })
    return resource
  }

  private bindTimeupdate() {
    if (this.player) {
      this.player.on('timeupdate', () => {
        this.emit(PlayerStatus.playing, this.getTime())
      })
    }
  }

  private createPlayerVideo() {
    const videoEl = document.createElement('video')
    videoEl.id = `${this.options.id}${new Date().getTime()}_video_container`
    videoEl.setAttribute('style', `width: ${this.options.width};height: ${this.options.height};`)
    this.playerBox.appendChild(videoEl)
    this.options.id = videoEl.id
    return videoEl
  }

  private bindEvents() {
    this.player.controlBar.progressControl.seekBar.on('sliderinactive', () => {
      this.emit('seek', this.getTime())
    })
    this.player.on('ended', () => {
      this.emit('end')
    })
  }

  destroy(): boolean {
    const container = document.querySelector(`#${this.options.id}`)
    if (container) {
      container.remove()
      this.player.dispose()
    }
    return false
  }

  stop(): void {
    this.pause()
    this.emit(PlayerStatus.stop)
  }

  getDuration(): number {
    return this.player.duration()
  }

  getTime(): number {
    return this.player.currentTime()
  }

  muted(mute: boolean): boolean {
    return this.player.muted(mute)
  }

  pause(): void {
    this.player.pause()
    this.emit(PlayerStatus.paused)
  }

  play(time?: number): void {
    if (Object.prototype.toString.call(time) === '[object Number]') {
      setTimeout(() => {
        this.player.currentTime(time)
      })
      return
    }
    this.player.play()
  }

  setTime(time: number) {
    // 123
    console.log(time)
  }
}

export default HwCloudWebPlayer
